import TabToggleList from 'components/commons/tab-toogle-list'
import { Button, InlineError, Input } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'
import MultipleSelect from 'components/commons/multiple-select'

export const CategoryItem = ({
    items,
    setItems,
    onChangeItem,
    optionsProduct,
    onSearchProduct,
    onAddNewItem,
    errorForm,
}) => {
    const getError = (key, index) => {
        const findError = errorForm?.categories_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <div className={'flex flex-col space-y-6'}>
            {items?.map((item, index) => (
                <TabToggleList
                    key={`category-item-${index}`}
                    index={index}
                    title={`Category-Item-${index + 1}`}
                    content={
                        <div className={'flex flex-col space-y-5'}>
                            <div className={'flex-1 flex-col space-y-3 w-1/2'}>
                                <div className={'font-semibold text-blue-90 required'}>Title</div>
                                <Input
                                    className={'flex-1'}
                                    name={'category_name'}
                                    placeholder={'Masukkan title'}
                                    value={item?.category_name}
                                    onChange={(item) => onChangeItem({ ...item, index })}
                                />
                                <InlineError className='mt-2' message={getError('category_name', index)} />
                            </div>
                            <div className={'flex-1 flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90 required'}>Pilih Product</div>
                                <MultipleSelect
                                    name={'product_ids'}
                                    placeholder={'Search Product...'}
                                    onSearch={onSearchProduct}
                                    value={item?.product_ids}
                                    options={optionsProduct}
                                    onChange={(item) => onChangeItem({ ...item, index })}
                                />
                                <InlineError className={'mt-2'} message={getError('product_ids', index)} />
                            </div>
                        </div>
                    }
                    items={items}
                    setItems={setItems}
                    isDisableDelete={items?.length === 1}
                    isSorting
                />
            ))}
            <InlineError className='mt-2' message={errorForm?.categories} />
            <Button
                className={'w-fit'}
                type={'outline'}
                icon={icAddSquare}
                title={'Add New Item'}
                onClick={onAddNewItem}
            />
        </div>
    )
}
